import { schema } from 'normalizr';
import { categorySchema } from './core';

export const glossarySchema = new schema.Entity('glossaries', {
  category: categorySchema
});

export const glossaryItemSchema = new schema.Entity('glossaryItems', {
  glossary: glossarySchema
});